import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';
import Select from 'react-select'
export default function HomeTwoBanner(){
	const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
	const options = [
		{ value: 'it-solutions', label: 'IT Solutions' },
		{ value: 'corporate', label: 'Corporate' },
		{ value: 'agency', label: 'IT Agecny' }
	  ]
    return(
        <>
		<ModalVideo channel='youtube' isOpen={isOpen} videoId='lTxn2BuqyzU' onClose={() => { openModal(); }} />
        <div id="slider-one" className="main-slider-area">
			<div className="slider-bg2">
				<div className="container">
					<div className="row align-items-center">
					
						<div className="col-xl-7 col-lg-9">
							<div className="slider__content2">
								<div className="video-slide d-flex align-items-center">
								<Link className="popup-video" onClick={() => { openModal(); }}><i className="fa fa-play"></i></Link>
									<h6>How It Works?</h6>
								</div>
								<h1 className="main-title-two mb-50">IT Product<br /> Development</h1>
								<form className="slider-form">
									<div className="input-box name">
										<input className="name" type="text" placeholder="Your name" />
									</div>
									<div className="input-box email">
										<input className="name email" type="text" placeholder="Email address" />
									</div>
									<div className="inquery-select input-box select-sub">
									<Select options={options} />
									</div>
									<div className="slider-form-btn">
										<button className="subscribe-btn">Submit Now</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        </>
    )
}